import { render } from "./RCSDeatailsPage.vue?vue&type=template&id=5114f398"
import script from "./RCSDeatailsPage.vue?vue&type=script&lang=js"
export * from "./RCSDeatailsPage.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__